export default "__VITE_ASSET__DbIPYZWj__"